import Service from "../pages/service/add";
import TeamMemberTable from "../pages/teamMember/teamMemberTable";
import TeamMemberData from "../pages/teamMember/teamMemberData";

const routesTeamMember = [
  {
    path: "/team-members",
    element: <TeamMemberTable />,
  },
  {
    path: "/team-member/data",
    element: <TeamMemberData />,
  },
];

export default routesTeamMember;
